import React, { FC } from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Stake, StakeBlank } from '../../../../../StakeRepresentation';

import styles from './RegularLine.module.scss';

// ---

const REGULAR_GRID_COLUMNS = [1, 2];

type RegularLineProps = {
  visibleStakeIds: List<number>;
  matchId: number;
};

const RegularLine: FC<RegularLineProps> = ({
  visibleStakeIds,
  matchId,
}) => {
  const _className = classNames(styles.stakeContainer,
    { [styles.smallContent]: REGULAR_GRID_COLUMNS.includes(visibleStakeIds.size) },
  );

  return (
    <div className={_className}
         data-test={`regular-line-${matchId}`}>
      {visibleStakeIds?.map((stakeId, index) => {
        const key = stakeId ? `${stakeId}-${index}` : `${matchId}-${index}/blank`;

        return (
          <div className={styles.stakeItem}
               key={key}>
            {stakeId ? (
              <Stake matchId={matchId}
                     stakeId={stakeId}
                     className={styles.innerLineStake} />
            ) : (
              <StakeBlank className={styles.innerLineStake} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RegularLine;
